import PDFViewer from "./PDFViewer";
import ImageGallery from "./ImageGallery";

const AttachmentViewer = ({ files, boundingBox, localUrl, docStatus }) => {
  const hasFiles = Array.isArray(files) && files.length > 0;
  const url =
    localUrl ||
    (hasFiles ? `${process.env.REACT_APP_API_URL}${files[0]?.url}` : "");

  if (!hasFiles) {
    return <div>Nessun file disponibile</div>;
  }

  return (
    <>
      {files.filter((f) => f?.extension?.toLowerCase() === "pdf").length > 0 ? (
        <PDFViewer url={url} boundingBox={boundingBox} docStatus={docStatus} />
      ) : (
        <ImageGallery
          url={url}
          boundingBox={boundingBox}
          docStatus={docStatus}
        />
      )}
    </>
  );
};

export default AttachmentViewer;
